import React from 'react'

import PropTypes from 'prop-types'

import {useDateFormat} from './hook-use-date-format'
/**
 * It's not a bug, is a feature! :D
 * You must use a hook instead
 */
function HookUseDateFormat({date}) {
  const formats = useDateFormat(date)

  const keys = Object.keys(formats)
  return (
    <>
      {keys.map((formatKey, index) => (
        <p key={index}>{formats[formatKey]}</p>
      ))}
    </>
  )
}

HookUseDateFormat.displayName = 'HookUseDateFormat'

HookUseDateFormat.propTypes = {
  date: PropTypes.string
}

export default HookUseDateFormat
